import { ReactComponent as SearchSVG } from '@assets/SVGs/PresenteeismTable/SearchSVG.svg'
import styles from '@styles/components/Novedades/NovedadesReferencias.module.css'
import { useState } from 'react'

const NovedadesReferencias = ({ novedades }) => {

    const [searchField, setSearchField] = useState("")

    const handleSearchBarTyping = (e) => {
        setSearchField(e.target.value.toLowerCase().replace(/\s/g, ''))
    }

    return (
        <div className={styles["popup"]}>
            <div className={styles['novedadpicker-search-bar']}>
                <div className={styles['novedadpicker-svg-container']}>
                    <SearchSVG/>
                </div>

                <div className={styles['novedadpicker-search-field-container']}>
                    <input type='text' placeholder='Buscar novedad...' className={styles['novedadpicker-search-input']} onChange={e => {handleSearchBarTyping(e)}}/>
                </div>
            </div>

            <div className={styles["scrollable-grid"]}>
                {novedades
                .filter(novedad => novedad.name.toLowerCase().replace(/\s/g, '').includes(searchField.toLowerCase().replace(/\s/g, '')))
                .map(novedad =>
                    <p><span style={{fontWeight: "600"}}>{novedad.acronym}</span> {novedad.name}</p>
                )}

            </div>
        </div>
    )
}

export default NovedadesReferencias